import React, { useEffect, useState } from 'react';
import { useMarks } from '../../DataStore/MarksContext';
import TextInput from '../Common/TextInput';
import CallOut from '../Common/CallOut';
import Notification from '../Common/Notification';
import ActivityLoader from '../Common/ActivityLoader';
import ajaxStaff from '../../util/remote/ajaxStaff'; // Must define
import { useConfig } from '../../DataStore/ConfigContext';
import { useStaff } from '../../DataStore/StaffContext';

const AssignSubject = ({ teacherId }) => {
  const {
    paperListing,
    getSubjectPapers,
    dispatch
  } = useMarks();
 const { classes, getClasses } = useConfig();
 const {loadProfile} = useStaff();
 const [notify, setNotify] = useState(null);
 const [loading, setLoading] = useState(false);
 const [staffClass, setStaffClass] = useState(null);
 const [staffSubject, setStaffSubject] = useState(null);
 const [staffStream, setStaffStream] = useState(null);

 useEffect(() => {
     getClasses();
     getSubjectPapers();
   }, []);
 


  useEffect(() => {
    if (notify) {
      const timeout = setTimeout(() => setNotify(null), 5000);
      return () => clearTimeout(timeout);
    }
  }, [notify]);




  const classOptions = Array.isArray(classes)
    ? classes.map(cls => ({
        label: `${cls.class_name} (${cls.level?.level || ''})`,
        value: cls,
        streams: cls.streams || [],
      }))
    : [];

  const streamOptions = staffClass?.streams?staffClass.streams.map(s => ({ label: s.stream_name, value: s.stream_id })) : [];

  const subjectOptions = Array.isArray(paperListing) && staffClass?.level?.level_id
    ? paperListing
        .filter(paper => paper.subject.level.level_id === staffClass.level.level_id)
        .map(paper => ({ label: `${paper.subject.subject} (${paper.paper_code})`, value: paper.paper_id }))
    : [];





  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!teacherId || !staffSubject?.value || !staffClass?.class_id) {
      setNotify(<Notification type="danger" message="Please select paper and class." />);
      return;
    }

    setLoading(true);

    const payload = {
      teacher_id: teacherId,
      paper_id: staffSubject.value,
      class_id: staffClass.class_id,
      stream_id: staffStream?.value || 0,
    };
    console.log('Assigning subject with payload:', payload);
    const response = await ajaxStaff.assignSubject(payload);
    setLoading(false);

    if (response.status === "OK") {
      loadProfile(teacherId); // Reload the teacher's profile to reflect changes
      setNotify(<Notification type="success" message={response.message} />);
      dispatch({ type: 'staffSubject', payload: null });
      dispatch({ type: 'staffClass', payload: null });
      dispatch({ type: 'staffStream', payload: null });
    } else {
      setNotify(<Notification type="danger" message={response.message} />);
    }
  };

  
  console.log(teacherId);

  return (
    <div className="card-body">
      <CallOut
        title="Assign Subject"
        description="Add teaching load to staff member by assigning a subject paper to a class and stream."
      />
      {notify}

      <form className="form-horizontal" onSubmit={handleSubmit}>

            <TextInput
                label="Class"
                placeholder='Select class'
                type="select"
                options={classOptions}
                onChange={(item) => setStaffClass(item.value)}
                wrap
                required
            />
            {streamOptions.length > 0 && (
                <TextInput
                label="Stream"
                placeholder='Select stream'
                type="select"
                options={streamOptions}
                onChange={(item) => setStaffStream(item)}
                wrap
                required
                />
            )}
            <TextInput
                label="Subject Paper"
                placeholder='Select subject paper'
                type="select"
                options={subjectOptions}
                onChange={(item) => setStaffSubject(item)}
                wrap
                required
            />


       
        <div className="text-right">
          {!loading && <button type="submit" className="btn btn-lg btn-primary">Assign Subject</button>}
          {loading && <ActivityLoader />}
        </div>
      </form>
    </div>
  );
};

export default AssignSubject;
